export default __webpack_public_path__ + "static/media/TravelerAnonymous.01c3dabd.jpg";